
















































import Vue from 'vue';
import { mapActions } from 'vuex';
import { SystemError } from '@/models/error/error';

type CallbackStatus = 'loading' | 'unauthorized' | 'error';

export default Vue.extend({
  name: 'MicrosoftCallbackView',

  data() {
    return {
      status: 'loading' as CallbackStatus,
      // Populated on error so the "Back to sign in" button re-embeds the pending
      // redirect in the URL rather than leaving it in sessionStorage where it could
      // bleed into a later, unrelated sign-in flow.
      pendingRedirect: null as string | null,
      pendingOtherQuery: {} as Record<string, any>
    };
  },

  computed: {
    backToSignInRoute(): Record<string, any> {
      const query: Record<string, any> = { ...this.pendingOtherQuery };
      if (this.pendingRedirect) {
        query.redirect = this.pendingRedirect;
      }
      return { name: 'sign-in', query };
    }
  },

  async created() {
    const { code, state } = this.$route.query as Record<string, string>;

    if (!code || !state) {
      this.captureAndClearPendingRedirect();
      sessionStorage.removeItem('microsoft_state');
      this.status = 'error';
      return;
    }

    try {
      await this.handleMicrosoftCallback({ code, state });
    } catch (error) {
      this.captureAndClearPendingRedirect();
      sessionStorage.removeItem('microsoft_state');
      if (SystemError.isSystemError(error) && error.statusCode === 403) {
        this.status = 'unauthorized';
      } else {
        this.status = 'error';
      }
      return;
    }

    const redirect = sessionStorage.getItem('microsoft_redirect');
    const otherQuery = sessionStorage.getItem('microsoft_other_query');
    sessionStorage.removeItem('microsoft_redirect');
    sessionStorage.removeItem('microsoft_other_query');

    let parsedOtherQuery = {};
    if (otherQuery) {
      try {
        parsedOtherQuery = JSON.parse(otherQuery);
      } catch {
        parsedOtherQuery = {};
      }
    }

    if (redirect) {
      this.$router.replace({ path: redirect, query: parsedOtherQuery });
    } else {
      this.$router.replace({ name: 'home', query: parsedOtherQuery });
    }
  },

  methods: {
    ...mapActions({
      handleMicrosoftCallback: 'microsoftAuth/handleMicrosoftCallback'
    }),

    captureAndClearPendingRedirect() {
      const redirect = sessionStorage.getItem('microsoft_redirect');
      const otherQueryRaw = sessionStorage.getItem('microsoft_other_query');
      sessionStorage.removeItem('microsoft_redirect');
      sessionStorage.removeItem('microsoft_other_query');
      this.pendingRedirect = redirect;
      if (otherQueryRaw) {
        try {
          this.pendingOtherQuery = JSON.parse(otherQueryRaw);
        } catch {
          this.pendingOtherQuery = {};
        }
      }
    }
  }
});
